import { render } from "./HistoryRouter.vue?vue&type=template&id=4f99d7a6&scoped=true"
import script from "./HistoryRouter.vue?vue&type=script&lang=js"
export * from "./HistoryRouter.vue?vue&type=script&lang=js"

import "./HistoryRouter.vue?vue&type=style&index=0&id=4f99d7a6&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f99d7a6"]])

export default __exports__